import { render } from "./RewardCardComponent.vue?vue&type=template&id=5fad16b9"
import script from "./RewardCardComponent.vue?vue&type=script&lang=js"
export * from "./RewardCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4021922066/src/flip-child-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg,QCarousel,QCarouselSlide,QCardSection});
